import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';

const Textarea = React.forwardRef(({ background, label, onChange, placeholder, value, rows, ...props }, externalRef) => {
  const internalRef = useRef(null);
  const textareaRef = externalRef || internalRef;

  const adjustHeight = (element) => {
    if (!element) return;

    element.style.height = '0px';
    element.style.height = 'auto';
    element.style.height = `${element.scrollHeight}px`;
  };

  useEffect(() => {
    const textareaElement = textareaRef.current;
    if (textareaElement && value) {
      adjustHeight(textareaElement);
    }
  }, []);

  useEffect(() => {
    const textareaElement = textareaRef.current;
    if (textareaElement) {
      if (!value) {
        textareaElement.style.height = 'auto';
      } else {
        adjustHeight(textareaElement);
      }
    }
  }, [value]);

  const handleChange = (e) => {
    adjustHeight(e.target);
    onChange(e);
  };

  return (
    <div className={clsx('textarea', `textarea--background-${background}`)}>
      {label && <label className="textarea__label">{label}</label>}
      <textarea {...props} ref={textareaRef} className="textarea__input" placeholder={placeholder} onChange={handleChange} value={value} rows={rows} />
    </div>
  );
});

Textarea.displayName = 'Textarea';

Textarea.propTypes = {
  background: PropTypes.oneOf(['default', 'grey']),
  label: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  rows: PropTypes.number,
};

Textarea.defaultProps = {
  background: 'default',
  onChange: () => null,
  value: '',
  rows: 1,
};

export default Textarea;
